.theme-brand-signnow {
  .call-to-action-type-11 {
    .call-to-action-type-11__content {
      border: none;
      border-radius: 1rem;
      background-color: $color-brand-primary-darkest;
      color: $color-neutral-white;
      text-align: center;
    }

    .call-to-action-type-11__intro {
      @include below($breakpoint-desktop) {
        padding: var(--spacing-3xl);
      }

      .me-text--label {
        text-transform: uppercase;
        letter-spacing: 3px;
        font-size: map-get($font-sizes, xs);
        font-weight: map-get($font-weights, bold);
      }
    }
  }
}
